import type { ItemSearchMatch } from "~/services/aiOrchestrator";

const pickJevItemSuggestions = (
	matches: readonly ItemSearchMatch[],
	shownItemIds: readonly string[]
): ItemSearchMatch[] => {
	const offeredTier = matches.some((match) => match.tier === "SUGGESTED") ? "SUGGESTED" : "CHECK";
	const seenItemIds = new Set(shownItemIds);
	return matches.filter((match) => {
		if (match.tier !== offeredTier || seenItemIds.has(match.itemId)) return false;
		seenItemIds.add(match.itemId);
		return true;
	});
};

export default pickJevItemSuggestions;
